import { PostDetailsController } from './post-details.controller'

function postDetails () {
  return {
    restrict: 'E',
    scope: {
      postId: '<',
      loading: '=',
      unread: '=',
      trackReactions: '<'
    },
    templateUrl: '/posts/directives/post-details/post-details-directive.html?$$REVISION$$',
    controller: PostDetailsController
  }
}

export { postDetails }
